import React from "react";
import { useWebsiteRoutes } from "hooks";
import { NavigationPageItems } from "components";

export const WebsitesNavigationPage: React.FC = () => {
  const { WebsiteNavigationRoot } = useWebsiteRoutes();
  return <NavigationPageItems navigationRoot={WebsiteNavigationRoot} />;
};
